var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0244,
    y: 17.2754,
    width: 38,
    height: 48,
    rx: 4,
    transform: "rotate(13.2865 34.0244 17.2754)",
    fill: "#393939"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13,
    width: 38,
    height: 48,
    rx: 4,
    fill: "#8C52FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 29.7496H42.375V28.3746C42.3748 27.5644 42.0832 26.7813 41.5534 26.1683C41.0236 25.5554 40.2911 25.1534 39.4895 25.0358C38.6879 24.9182 37.8707 25.0928 37.1872 25.5278C36.5037 25.9628 35.9994 26.6291 35.7665 27.4051C35.743 27.4837 35.7351 27.5662 35.7435 27.6479C35.7518 27.7295 35.7762 27.8087 35.8151 27.881C35.8541 27.9532 35.9069 28.0171 35.9705 28.0689C36.0341 28.1208 36.1074 28.1596 36.186 28.1831C36.2646 28.2066 36.3471 28.2145 36.4288 28.2061C36.5104 28.1978 36.5896 28.1734 36.6619 28.1345C36.7341 28.0955 36.798 28.0427 36.8498 27.9791C36.9017 27.9154 36.9405 27.8422 36.964 27.7636C37.1108 27.2751 37.4284 26.8558 37.8588 26.5821C38.2892 26.3083 38.8037 26.1985 39.3083 26.2726C39.8129 26.3467 40.2741 26.5998 40.6076 26.9857C40.9411 27.3716 41.1248 27.8645 41.125 28.3746V29.4996C41.125 29.5659 41.0987 29.6295 41.0518 29.6764C41.0049 29.7233 40.9413 29.7496 40.875 29.7496H35.25C34.9848 29.7496 34.7304 29.8549 34.5429 30.0425C34.3554 30.23 34.25 30.4844 34.25 30.7496V35.9996C34.25 36.2648 34.3554 36.5192 34.5429 36.7067C34.7304 36.8942 34.9848 36.9996 35.25 36.9996H42.75C43.0152 36.9996 43.2696 36.8942 43.4571 36.7067C43.6446 36.5192 43.75 36.2648 43.75 35.9996V30.7496C43.75 30.4844 43.6446 30.23 43.4571 30.0425C43.2696 29.8549 43.0152 29.7496 42.75 29.7496ZM39 34.2496C38.8022 34.2496 38.6089 34.1909 38.4444 34.0811C38.28 33.9712 38.1518 33.815 38.0761 33.6323C38.0004 33.4495 37.9806 33.2485 38.0192 33.0545C38.0578 32.8605 38.153 32.6823 38.2929 32.5425C38.4327 32.4026 38.6109 32.3074 38.8049 32.2688C38.9989 32.2302 39.2 32.25 39.3827 32.3257C39.5654 32.4014 39.7216 32.5296 39.8315 32.694C39.9414 32.8585 40 33.0518 40 33.2496C40 33.5148 39.8946 33.7692 39.7071 33.9567C39.5196 34.1442 39.2652 34.2496 39 34.2496Z",
    fill: "#EEE7FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 48,
    width: 30,
    height: 8,
    rx: 4,
    fill: "#C9B3FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 51,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#EEE7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9897 4.15828C62.7914 5.4106 62.2841 6.59435 61.5142 7.60185C61.2979 7.88503 61.2429 8.25927 61.3753 8.59021C61.5077 8.92095 61.8057 9.15404 62.1575 9.20979C63.4099 9.40807 64.5936 9.91536 65.6011 10.6853C65.8843 10.9016 66.2585 10.9566 66.5895 10.8242C66.9202 10.6918 67.1533 10.3938 67.2091 10.0418C67.4074 8.78944 67.9146 7.60589 68.6845 6.59839C68.9009 6.31521 68.9559 5.94097 68.8235 5.61003C68.6911 5.27929 68.393 5.04619 68.0412 4.99045C66.7889 4.79217 65.6054 4.28491 64.5979 3.515C64.3147 3.29862 63.9404 3.24365 63.6095 3.37605C63.2786 3.50826 63.0455 3.80628 62.9897 4.15828Z",
    fill: "#FFE5CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01784 48.5955C4.91641 49.2362 4.65691 49.8417 4.26306 50.3571C4.15237 50.5019 4.12425 50.6934 4.19198 50.8627C4.25973 51.0319 4.41218 51.1511 4.59214 51.1796C5.23276 51.2811 5.83831 51.5406 6.3537 51.9344C6.49856 52.0451 6.69 52.0732 6.85929 52.0055C7.02848 51.9377 7.14772 51.7853 7.17625 51.6052C7.27768 50.9646 7.53717 50.3592 7.93102 49.8438C8.0417 49.6989 8.06983 49.5075 8.0021 49.3382C7.93435 49.169 7.78189 49.0497 7.60193 49.0212C6.96131 48.9198 6.35587 48.6603 5.84048 48.2665C5.69562 48.1558 5.50418 48.1276 5.33489 48.1954C5.16561 48.263 5.04637 48.4155 5.01784 48.5955Z",
    fill: "#C9B3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockBlack);
export default __webpack_public_path__ + "static/media/unlock-black.a14a52a4a3d38accf6a1905e7da8f172.svg";
export { ForwardRef as ReactComponent };